<template>
  <div class="hy-info" :class="thisStatus == 0 ? 'baoming':''">
    <div class="info-cont">
      <div class="info-listbox">
        <div class="info_item info_list" >
          <h5>{{postsData.title == '' ? '列表页':postsData.title}}</h5>
          <div class="info_item_list">
            <ul v-if="postsData.result.list.length >0">
              <li v-for="(item,index) in postsData.result.list" :key="index">
                <router-link class="nav-link iconfont" :to="{ name: 'listinfoPage', params: { id: item.id }}" v-if="item.jump_url == ''">
                <!--  <div class="imgbox">
                      <img :src="item.img_url" alt />
                  </div>-->
                  <div class="textbox">
                    <h5> {{item.title}}
                    </h5>
                    <p class="time">{{item.publish_time,'Y-M-D h:m'|formatDates}}</p>
                  </div>
                </router-link>
                <a  class="nav-link iconfont" :href="item.jump_url" v-else>
                  <div class="textbox">
                    <h5> {{item.title}}
                    </h5>
                    <p class="time">{{item.publish_time,'Y-M-D h:m'|formatDates}}</p>
                  </div>
                </a>
              </li>
            </ul>
            <div v-else style="text-align: center;padding:20px 0px;">
              暂无列表内容
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--底部按钮-->
  <!--  <div class="hy-fixed-userBtn">
      <span class="iconfont fixed-link" @click="openFooterNav()">&#xe60c;</span>
      <div class="hy_footer_nav" :class="footerNav? 'active':''">
        <router-link class="nav-link iconfont" to="/">
          &#xe60e;
          <span class="text">会议平台首页</span>
        </router-link>
        <router-link class="nav-link iconfont" to="/myEnroll">
          &#xe609;
          <span class="text">我的会议信息</span>
  </router-link>
      </div>
    </div>-->
    <template v-if="postsData.title != ''">
      <footerFixed :id="postsData.result.conference_id" :jump-page="postsData.result.jump_page"/>
    </template>

  </div>
</template>
<script>
  import {
    formatDates
  } from '@/assets/js/date.js';
  import {
    getCookie,
    delCookie,
    setCookie
  } from '../../http/util'; // cookie操作
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
    data() {
      return {
        id: "",
        footerNav: false,
        postsData: {
            title:'',
            result:[]
        },
        thisStatus: 0,
      };
    },
    created() {
      var _this= this;
      this.id = this.$route.params.id;
      this.list();
    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    methods: {
      //banner跳转方法
      goPath(path) {
        this.$router.push(path);
      },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
      list() {
        var _this = this;
        let url = "/ac1/conference/column/listInfo";
        let params = {
          id: _this.id
        };
        _this.$get(url, params).then(res => {
          document.title = res.posts.title;
          _this.postsData = res.posts;
          var wxShareInfo ={
            title:_this.postsData.title,
            info:'栏目列表',
            shareurl:window.location.href,
            img:_this.postsData.result.list[0].img_url
          };
          _this.$WXConfig.wxShowMenu({ifshare:true,that:_this,data:wxShareInfo});
        });
      },
    }
  };
</script>
<style lang="less" scoped>
  //详情页版块样式
  .hy-info {
    width: 100%;
    min-height: 100vh;
    background: #f7f7f7;

    .info-cont {
      width: 100%;

      .info-listbox {
        width: 100%;

        .info_item {
          width: 100%;
          background: #fff;
          padding: 30px;
          margin-bottom: 20px;

          >h5 {
            font-size: 32px;
            font-weight: 600;
            line-height: 45px;
            color: #333333;
            display: inline-block;
            text-align: left;
            padding: 0 10px;
            position: relative;
            background-image: url(../../assets/images/index/hy_titlebg.png);
            background-position: left center;
            background-repeat: no-repeat;
            background-size: 155px auto;
            overflow: hidden;
            width: 100%;

            a {
              float: right;
              font-size: 26px;
              color: #a3a3a3;
              font-weight: 400;
            }
          }

          >div {
            ul {
              width: 100%;
            }
          }
          &.info_list {
            .info_item_list {
              padding: 0px 0px;

              ul {
                width: 100%;

                li {
                  width: 100%;
                  overflow: hidden;
                  border-bottom: 1px solid #ebebeb;
                  padding: 20px 0px;

               /*   .imgbox {
                    float: left;
                    width: 210px;
                    height: 140px;
                    position: relative;
                    margin-right: 20px;
                    background: #ebebeb;
                    img {
                      width: 100%;
                      height: 100%;
                      display: block;
                    }
                  }*/

                  .textbox {
                    width: 100%;
                  /*  height: 140px;*/
                    float: left;
                    position: relative;

                    h5 {
                      line-height: 35px;
                      overflow: hidden;
                      font-size: 28px;
                      color: #333;
                    }

                    .time {
                      font-size: 24px;
                      color: #8e8e8e;
                      line-height: 35px;
                    }

                    .hy_bottom {
                      width: 100%;
                      font-size: 24px;
                      color: #8e8e8e;
                      line-height: 20px;
                      overflow: hidden;

                      .num {
                        float: left;
                        font-size: 24px;
                        color: #8e8e8e;
                        line-height: 35px;
                      }

                      .hy_zanBtn {
                        float: right;
                        font-size: 24px;
                        color: #8e8e8e;
                        line-height: 35px;

                        &.active {
                          color: #fd882b;
                        }
                      }
                    }
                  }

                  &:last-child {
                    border: none;
                  }
                }
              }
            }
          }
        }
      }
    }

  }
</style>
</style>
